import RechnerTemplate from './Rechner_template'
import _ from 'lodash'

var rechnerMixin = {
  //===========================================================================================================
  data: function () {
    // steps werden aus this.components ausgelsen und generiert:
    var steps_config = {}
    var i = 0;
    for (var key in this.$options.components) {
      if (key.substr(0, 5) === "Step_") {
        i++;

        var component = this.$options.components[key]
        var fieldDefs = this.$store.state.rechnerConfig.fieldDefs
        var values = {}
        //console.log('A1) comp fieldeys: ', component.fieldKeys)
        //console.log('A2) rechner Config: ', this.$store.state.rechnerConfig)
        _.forEach(component.fieldKeys, function (fieldName) {
           //console.log('B) build DefValues: ', fieldName)
          var defaultValue = fieldDefs[fieldName].default_value
          //console.log('C) build DefValues: ', fieldName, defaultValue)
          if (defaultValue !== null) {
            defaultValue = String(defaultValue);
          }
          values[fieldName] = defaultValue;

        });


        if (this.$route.params.vermittlerNr > '') {
          // values['abschluss_Vermittler_nr'] = this.$route.params.vermittlerNr;
        }

        steps_config[key] = {
          name: key,
          stepNr: i,
          component: component,
          label: component.label,
          label2: component.label2,
          fieldKeys: component.fieldKeys,
          fieldValues: values, /*_.mapValues(_.invert(component.fieldKeys), _.constant(null)),*/
          $v: {
            $dirty: false,
            $error: false,
            $invalid: true,
            $pending: false,
          }
        }
      }
    }


    return {
      steps: steps_config,
      activeStepNr: null,
    }

  }, //========================================================================================================
  components: {RechnerTemplate},
  //========================================================================================================
  props: [],
  //===========================================================================================================
  computed: {},
  //========================================================================================================
  methods: {},
  //========================================================================================================
  //HOOKS:
  mounted() {
  }, //——————————————————————————————————————————————————————————————————————————————————————————————————————
// ========================================================================================================
}
export default rechnerMixin
